var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTabIconTransportation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.78,
    height: 36.015,
    viewBox: "0 0 34.78 36.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27283",
    "data-name": "Group 27283",
    transform: "translate(-12757.86 -3156.244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CRANE_TRUCK",
    "data-name": "CRANE TRUCK",
    transform: "translate(12758.46 3156.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustrationer",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37836",
    "data-name": "Path 37836",
    d: "M747.2,85.8v4.507l3.159,3.442",
    transform: "translate(-742.657 -74.284)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3795",
    "data-name": "Line 3795",
    x1: 3.318,
    y2: 3.442,
    transform: "translate(1.224 16.023)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37837",
    "data-name": "Path 37837",
    d: "M747.8,130.6v2.449a.75.75,0,0,1-.745.745h-4.969a.75.75,0,0,1-.745-.745V130.6h-.408a.833.833,0,0,0-.834.834v10.54a.833.833,0,0,0,.834.834h7.293a.833.833,0,0,0,.834-.834v-10.54a.833.833,0,0,0-.834-.834Z",
    transform: "translate(-740.1 -111.134)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37838",
    "data-name": "Path 37838",
    d: "M470.208,114.34h16.325a.413.413,0,0,0,.408-.408V94.608a.413.413,0,0,0-.408-.408H470.208a.413.413,0,0,0-.408.408v19.324A.425.425,0,0,0,470.208,114.34Z",
    transform: "translate(-455.242 -81.193)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37839",
    "data-name": "Path 37839",
    d: "M473.76,209.368H476.1a.159.159,0,0,0,.16-.16V207.86a.159.159,0,0,0-.16-.16H473.76a.159.159,0,0,0-.16.16v1.349A.159.159,0,0,0,473.76,209.368Z",
    transform: "translate(-445.237 -174.553)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37840",
    "data-name": "Path 37840",
    d: "M547.86,209.368H550.2a.159.159,0,0,0,.16-.16V207.86a.159.159,0,0,0-.16-.16H547.86a.159.159,0,0,0-.16.16v1.349C547.718,209.3,547.771,209.368,547.86,209.368Z",
    transform: "translate(-532.486 -174.553)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37841",
    "data-name": "Path 37841",
    d: "M566.477,121.36h1.544a.168.168,0,0,0,.177-.177v-3.105a.168.168,0,0,0-.177-.177h-1.544a.168.168,0,0,0-.177.177v3.105A.168.168,0,0,0,566.477,121.36Z",
    transform: "translate(-553.623 -100.688)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37842",
    "data-name": "Path 37842",
    d: "M459.378,121.36h1.544a.168.168,0,0,0,.177-.177v-3.105a.168.168,0,0,0-.177-.177h-1.544a.168.168,0,0,0-.177.177v3.105A.178.178,0,0,0,459.378,121.36Z",
    transform: "translate(-427.519 -100.688)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37843",
    "data-name": "Path 37843",
    d: "M477.31,123.886h13.309l.71-2.963V117.8l-3.354.6H479.9l-3.3-.6v3.123Z",
    transform: "translate(-460.836 -100.605)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37844",
    "data-name": "Path 37844",
    d: "M478.818,181.078,476.6,182.2l.692-2.4",
    transform: "translate(-448.326 -151.604)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37845",
    "data-name": "Path 37845",
    d: "M547.1,181.078l2.218,1.118-.692-2.4",
    transform: "translate(-531.336 -151.604)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3796",
    "data-name": "Line 3796",
    x1: 7.825,
    transform: "translate(19.225 28.498)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3797",
    "data-name": "Line 3797",
    x1: 5.59,
    transform: "translate(20.343 30.255)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1248",
    "data-name": "Ellipse 1248",
    cx: 1.26,
    cy: 1.26,
    rx: 1.26,
    ry: 1.26,
    transform: "translate(13.316)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1249",
    "data-name": "Ellipse 1249",
    cx: 1.26,
    cy: 1.26,
    rx: 1.26,
    ry: 1.26,
    transform: "translate(21.993 5.181)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3813",
    "data-name": "Line 3813",
    x1: 7.062,
    y1: 4.188,
    transform: "translate(15.8 0.994)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3814",
    "data-name": "Line 3814",
    x1: 6.849,
    y1: 4.205,
    transform: "translate(15.072 2.36)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26753",
    "data-name": "Group 26753",
    transform: "translate(4.145 0.532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37861",
    "data-name": "Path 37861",
    d: "M580.358,23.9l-9.393,9.547a1.588,1.588,0,0,0-.156.976h0c.034.408.147.639.259.55l9.364-9.6",
    transform: "translate(-570.8 -23.9)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_3815",
    "data-name": "Line 3815",
    y2: 5.696,
    transform: "translate(22.401 7.24)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3816",
    "data-name": "Line 3816",
    y2: 5.696,
    transform: "translate(24.104 7.24)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37862",
    "data-name": "Path 37862",
    d: "M537.112,45.936l2.908.308-.751-.53-2.118-.221a.234.234,0,0,0-.25.2h0A.24.24,0,0,0,537.112,45.936Z",
    transform: "translate(-520.227 -40.495)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39322",
    "data-name": "Path 39322",
    d: "M-1.283-.025-6.477-.51",
    transform: "translate(18.004 5.225)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeWidth: 1.2
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabIconTransportation);
export default __webpack_public_path__ + "static/media/TabIcon_Transportation.e1992cd0ccfb6c0d2c7df6d237d18ff5.svg";
export { ForwardRef as ReactComponent };